import React from 'react'

const Reorder = () => (
 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M5.76367 15L5.76367 5" stroke="#6B7073" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9.76367 15L9.76367 5" stroke="#6B7073" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M13.7637 15L13.7637 5" stroke="#6B7073" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
)

export default Reorder;
